import React from 'react';
import { translations } from '../translations';
import Layout from './Layout';

function Settings({ onLogout, language = 'de' }) {
  const t = translations[language] || translations.en;

  return (
    <div className="settings-container">
      <div className="settings-card">
        <div className="settings-section">
          <div className="section-header">
            <img src="/images/question.png" alt="Question" className="section-icon" />
            <h2 className="section-title">{language === 'de' ? 'Frage' : 'Question'}</h2>
          </div>
          <p className="section-description">
            {language === 'de' 
              ? 'Kontaktieren Sie uns bei Fragen zur Studie' 
              : 'Contact us for questions about the study'
            }
          </p>
          <div className="contact-email">
            <a href="mailto:forschung@buchinger-wilhelmi.com" className="email-link">
              forschung@buchinger-wilhelmi.com
            </a>
          </div>
        </div>

        <div className="settings-section">
          <div className="section-header">
            <img src="/images/logout.png" alt="Logout" className="section-icon" />
            <h2 className="section-title">{t.welcome.signOut}</h2>
          </div>
          <p className="section-description">
            {language === 'de' 
              ? 'Melden Sie sich von der Anwendung ab' 
              : 'Sign out from the application'
            }
          </p>
          <button onClick={onLogout} className="logout-btn-large">
            {t.welcome.signOut}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Settings; 